<template>
</template>

<script>
import request from "@/utils/request";
import { ElMessage } from 'element-plus'

// let main_activeIndex = "page1";

// tab页签索引
let device_tabs_index = "0";
// 后端服务器地址
// let flask_web_url = "http://192.168.1.77:7770/device";
let flask_web_url = SERVER_URL + "/device";
// let flask_web_url = "http://120.26.82.44:7770/device";
let flask_web_local_url = flask_web_url;
// flask_web_local_url = flask_web_url
let public_yAxis = {
	minInterval: 1,
	axisLine: {
		lineStyle: {
			color: "rgb(255, 255, 255)",
		}
	},
	axisLabel: {
		color: "rgb(255, 255, 255)", // y 轴文字颜色
		formatter: '{value}  ',
		fontSize: 14,
	},

}
let public_dataZoom = [{
	type: 'slider', // inside ,slider 
	throttle: '50', //设置触发视图刷新的频率。单位为毫秒（ms）。
	minValueSpan: 6, //用于限制窗口大小的最小值,在类目轴上可以设置为 5 表示 5 个类目
	start: 0, //数据窗口范围的起始百分比 范围是：0 ~ 100。表示 0% ~ 100%。
	end: 20, //数据窗口范围的结束百分比。范围是：0 ~ 100。
	zoomLock: false, //如果设置为 true 则锁定选择区域的大小，也就是说，只能平移，不能缩放。

	// backgroundColor: 'rgba(255, 255, 255, 1)',//组件的背景颜色
	selectedDataBackground: {//选中部分数据阴影的样式
		lineStyle: {
			color: 'rgba(0, 255, 127, 1.0)',
		},//选中部分阴影的线条样式
		areaStyle: {
			color: 'rgba(0, 255, 127, 1.0)',
		},//选中部分阴影的填充样式
	},
	fillerColor: 'rgba(170, 0, 0, 0.2)',//选中范围的填充颜色
	borderColor: 'rgba(85, 255, 255, 1.0)',//边框颜色。
	moveHandleSize: 10,//移动手柄的尺寸高度
	textStyle: {
		color: 'rgba(0, 255, 127, 1.0)',
		fontSize: 17,
		fontWeight: 700,
		position: "absolute",
		zIndex: 99,
		overflow: "auto",
	},
	labelFormatter(val, val2) {
		// console.log(val2)
		return val2.slice(5, 19)
	},
	// left:"20px"
	bottom: "30px",
}]
let public_tooltip = {
	show: true,
	trigger: 'axis',
	// 触发类型（'item'，数据项图形触发，主要在散点图，饼图等无类目轴的图表中使用；'axis'，坐标轴触发，主要在柱状图，折线图等会使用类目轴的图表中使用；'none'，不触发。）
	backgroundColor: "rgba(85, 170, 255, 1)",
	borderColor: "rgba(255, 255, 255, 1.0)",
	padding: [10, 15],
	textStyle: {
		color: "#fff"
	},
	axisPointer: {
		type: "cross",
		axis: 'auto', // 指示器的坐标轴。
		snap: true, // 坐标轴指示器是否自动吸附到点上  
		crossStyle: {
			color: "#55ffff",
		},
		lineStyle: {
			color: "#55ffff",
		},
		color: "#55ffff",
		label: {
			show: true,  //是否显示文本标签
			color: '#55ffff',
			backgroundColor: 'rgba(85, 170, 255, 1)',  //背景颜色，默认是和axis.axisLine.lineStyle.color 相同
			fontSize: 15,

		}
	},
	triggerOn: 'mousemove|click',
	// alwaysShowContent: true,
	// formatter: '{b0}<br/>{a0} : {c0}',
	// formatter: (params) => {
	// 	// console.log(params)
	// 	let str = `${params.name}
	// 	<div>
	// 		<div style="width: 10px;
	// 					height: 10px;
	// 					background-color: #00ff7f;
	// 					border-radius: 20px;
	// 					margin-top: 5px;
	// 					float:left">
	// 		</div>
	// 		<div style="float:right;margin-left: 5px;">
	// 			${params.seriesName}  :  ${params.data}
	// 		</div>
	// 	</div>
	// 	`
	// 	return str
	// },
	extraCssText: 'box-shadow: 0 0 4px 4px rgba(85, 255, 255, 0.8);',  //额外附加到浮层的 css 样式

}
let public_toolbox = {
	show: true,
	itemSize: 18,  //icon大小
	right: '10px',
	feature: {
		// myFull: {
		// 	backgroundColor: '#55aaff',
		// 	show: true,
		// 	iconStyle:{
		// 		// color: "#55ffff", 
		// 		borderColor: "#ffffff",
		// 		borderWidth: 1.2,
		// 		opacity: 1  //图形透明度
		// 	},
		// 	// hover
		// 	emphasis: {
		// 		iconStyle:{
		// 			borderColor: "#55ffff",
		// 			borderWidth: 1.5,
		// 			opacity: 1  ,//图形透明度
		// 			textPosition: 'left',  //文本位置，属性值：left/right/top/bottom
		//                   // textAlign: 'left',  //文本对齐方式，属性值：left/center/right
		// 			Size:20
		// 		}
		// 	},
		// 	title: "全屏查看",
		// 	icon: "path://M708.2 792.2l-97.5-97.7c-11.6-11.6-11.6-30.3 0-41.9l41.9-41.9c11.6-11.6 30.3-11.6 41.9 0l97.6 97.6 85.3-85.3c11.6-11.6 30.3-11.6 41.9-0.1 5.6 5.6 8.7 13.1 8.7 21v254.4c0 16.4-13.3 29.6-29.6 29.6H643.9c-16.4 0-29.6-13.3-29.6-29.6 0-7.8 3.1-15.4 8.6-20.9l85.3-85.3v0.1zM234 708.1l97.5-97.6c11.6-11.6 30.3-11.6 41.9 0l41.9 41.9c11.6 11.6 11.6 30.3 0 41.9l-97.6 97.6 85.3 85.3c11.6 11.6 11.5 30.4-0.1 41.9-5.6 5.5-13.1 8.6-20.9 8.6H127.7c-16.4 0-29.6-13.3-29.6-29.6V643.7c0-16.4 13.3-29.6 29.6-29.6 7.9 0 15.4 3.1 21 8.7l85.3 85.3zM792 318l-97.6 97.6c-11.6 11.6-30.3 11.6-41.9 0l-41.8-41.8c-11.6-11.6-11.6-30.3 0-41.9l97.6-97.6L623 149c-11.6-11.6-11.5-30.4 0.1-41.9 5.6-5.5 13.1-8.6 20.9-8.6h254.4c16.4 0 29.6 13.3 29.6 29.6v254.4c0 16.4-13.3 29.6-29.6 29.6-7.9 0-15.4-3.1-21-8.7L792 318z m-474.3-83.9l97.6 97.6c11.6 11.6 11.6 30.3 0 41.9l-42 42c-11.6 11.6-30.3 11.6-41.9 0L233.8 318l-85.3 85.3c-11.6 11.6-30.4 11.5-41.9-0.1-5.6-5.6-8.7-13.1-8.6-21V127.8c0-16.4 13.3-29.6 29.6-29.6H382c16.4 0 29.6 13.3 29.6 29.6 0 7.9-3.1 15.4-8.7 21l-85.2 85.3z",
		// 	onclick: () => {
		// 		let element = document.getElementById("data_chistory_show_1");
		// 		// 一些浏览器的兼容性
		// 		if (element.requestFullScreen) {
		// 			// HTML W3C 提议
		// 			element.requestFullScreen();
		// 		} else if (element.msRequestFullscreen) {
		// 			// IE11
		// 			element.msRequestFullScreen();
		// 		} else if (element.webkitRequestFullScreen) {
		// 			// Webkit (works in Safari5.1 and Chrome 15)
		// 			element.webkitRequestFullScreen();
		// 		} else if (element.mozRequestFullScreen) {
		// 			// Firefox (works in nightly)
		// 			element.mozRequestFullScreen();
		// 		}
		// 		// 退出全屏
		// 		if (element.requestFullScreen) {
		// 			document.exitFullscreen();
		// 		} else if (element.msRequestFullScreen) {
		// 			document.msExitFullscreen();
		// 		} else if (element.webkitRequestFullScreen) {
		// 			document.webkitCancelFullScreen();
		// 		} else if (element.mozRequestFullScreen) {
		// 			document.mozCancelFullScreen();
		// 		}
		// 	},
		// },
		// saveAsImage: { 
		// 	show: true ,
		// 	backgroundColor: '#55aaff',
		// 	iconStyle:{
		// 		borderColor: "#ffffff",
		// 		borderWidth: 1.5,
		// 	}
		// },							  
		// 数据视图只读
		// dataView: { 
		// 	readOnly: true ,
		// 	backgroundColor: '#55aaff',
		// 	show: true,
		// 	iconStyle:{
		// 		// color: "#55ffff", 
		// 		borderColor: "#ffffff",
		// 		borderWidth: 1.2,
		// 		opacity: 1  //图形透明度
		// 	},
		// 	// hover
		// 	emphasis: {
		// 		iconStyle:{
		// 			borderColor: "#55ffff",
		// 			borderWidth: 1.5,
		// 			opacity: 1  ,//图形透明度
		// 			// textPosition: 'top',  //文本位置，属性值：left/right/top/bottom
		// 	        // textAlign: 'left',  //文本对齐方式，属性值：left/center/right
		// 			Size:20
		// 		}
		// 	},
		// },
		// 魔法类型
		// magicType: { type: ['line', 'bar'] },
		//  重置
		restore: {
			backgroundColor: '#55aaff',
			show: true,
			iconStyle: {
				// color: "#55ffff", 
				borderColor: "#ffffff",
				borderWidth: 1.2,
				opacity: 1  //图形透明度
			},
			// hover
			emphasis: {
				iconStyle: {
					borderColor: "#55ffff",
					borderWidth: 1.5,
					opacity: 1,//图形透明度
					// textPosition: 'top',  //文本位置，属性值：left/right/top/bottom
					// textAlign: 'left',  //文本对齐方式，属性值：left/center/right
					Size: 20
				}
			},
		},


	},

}
// 数据图表1
let data_chistory_show_1 = "";
// 数据图表2
let data_chistory_show_2 = "";
// 数据图表3
let data_chistory_show_3 = "";
// 数据图表4
let data_chistory_show_4 = "";
// 数据图表5
let data_chistory_show_5 = "";
// 数据图表6
let data_chistory_show_6 = "";
// 数据图表6
let data_chistory_show_7 = "";
// 设备位置数据
/* ！！！  " "作为字符串分割的标注,要严格按照下列规范
	"<div style='color:#55aaff;'>地址 :武汉港 <br/>设备: device1 </div>"
*/
let map_data_info = [
	// [114.4393964, 30.4204975,"<div style='color:#55aaff;'>地址: 武汉港 <br/>设备: device1 </div>"],
	// [113.479880000162, 23.0573600002638,"<div style='color:#55aaff;'>地址: 广州市番禺区龙沙港 <br/>设备: device2 </div>"],
	//    [121.365398, 37.562242,"<div style='color:#55aaff;'>地址: 烟台市芝罘区烟台港 <br/>设备: device3 </div>"],
	// [120.018000, 30.075000,"<div style='color:#55aaff;'>地址: 杭州市富阳区东洲港 <br/>设备: device4 </div>"],
	// [121.655197, 38.935595,"<div style='color:#55aaff;'>地址: 大连市中山区大连港 <br/>设备: device5 </div>"],
	// [119.330395, 26.078802,"<div style='color:#55aaff;'>地址: 福州市晋安区福建港 <br/>设备: device6 </div>"],
	// [121.38898, 31.6192,"<div style='color:#55aaff;'>地址: 上海市崇明区南门港 <br/>设备: device7 </div>"],
	// [118.210738, 33.460494,"<div style='color:#55aaff;'>地址: 宿迁市泗洪县泗洪港 <br/>设备: device8 </div>"],
	// [114.4383964, 30.41804975,"<div style='color:#55aaff;'>地址: 武汉港 <br/>设备: device9 </div>"],
	// [114.44265, 30.41874,"<div style='color:#55aaff;'>地址: 武汉港 <br/>设备: device10 </div>"],
	// [113.48748, 23.05264,"<div style='color:#55aaff;'>地址: 广州港 <br/>设备: device11 </div>"],
	// [113.48182, 23.05355,"<div style='color:#55aaff;'>地址: 广州港 <br/>设备: device12 </div>"],
	// [111.28155, 30.69608,"<div style='color:#55aaff;'>地址: 宜昌港 <br/>设备: device13 </div>"],
	// [111.27867, 30.6955,"<div style='color:#55aaff;'>地址: 宜昌港 <br/>设备: device14 </div>"],
	// [111.28219, 30.69291,"<div style='color:#55aaff;'>地址: 宜昌港 <br/>设备: device15 </div>"],

];
// 天地图对象
let tdtMap = {};
// 地图标记数组
let map_marker = [];
// 地图标记内容数组
let map_marker_content = [];
// 地图label对象
let map_label = [];
// 设备数据中选择的当前device_id
let now_device_id = ""
let markers_list = ""
let device_info_data_obj = {
	"device_id": "",
	"region": "",
	"address": "",
	"lon": "",
	"lat": "",
}











let api_list_data = [
	{
		"id": 1,
		"title": "产品缺陷检测",
		"content": "针对提供的产品进行AI训练，实现缺陷检测。例如对指定PCB板中的头发、褶皱、多料、少料、裂缝等缺陷进行检测识别。",
		"show_content": [],
		"style": "margin-top: 10px;margin-left: 14px;height: 180px;width: 200px;",
		"show_style": ""
	}, {
		"id": 2,
		"title": "图片清晰化",
		"content": "可以恢复模糊图像的细节和清晰度，使处理后的图像更符合人眼观察需求，消除因抖动、对焦不准等原因导致的模糊。",
		"show_content": [],
		"style": "margin-top: 10px;margin-left: 14px;height: 180px;width: 200px;",
		"show_style": ""
	},
	{
		"id": 3,
		"title": "证件照生成",
		"content": "可根据上传的图片生成一张标准证件照。",
		"show_content": [],
		"style": "margin-top: 10px;margin-left: 14px;height: 180px;width: 200px;",
		"show_style": ""
	},
	{
		"id": 5,
		"title": "人像抠图",
		"content": "可将上传图片中人物图像单独抠出。",
		"show_content": [],
		"style": "margin-top: 10px;margin-left: 14px;height: 180px;width: 200px;",
		"show_style": ""
	},
	{
		"id": 4,
		"title": "ico图标转换",
		"content": "可将上传图片转换成ico图标。",
		"show_content": [],
		"style": "margin-top: 10px;margin-left: 14px;height: 180px;width: 200px;",
		"show_style": ""
	},
	{
		"id": 6,
		"title": "AI生成思维导图",
		"content": "可设定主题让AI生成思维导图",
		"show_content": [],
		"style": "margin-top: 10px;margin-left: 14px;height: 180px;width: 200px;",
		"show_style": ""
	},
	{
		"id": 7,
		"title": "中外文翻译",
		"content": "中外文翻译",
		"show_content": [],
		"style": "margin-top: 10px;margin-left: 14px;height: 180px;width: 200px;",
		"show_style": ""
	},
	{
		"id": 8,
		"title": "AI生成PPT",
		"content": "可设定主题让AI生成PPT",
		"show_content": [],
		"style": "margin-top: 10px;margin-left: 14px;height: 180px;width: 200px;",
		"show_style": ""
	},
	{
		"id": 9,
		"title": "文档整理",
		"content": "文档整理",
		"show_content": [],
		"style": "margin-top: 10px;margin-left: 14px;height: 180px;width: 200px;",
		"show_style": ""
	},
	// {
	// 	"id": 10,
	// 	"title": "AI销售助手",
	// 	"content": "AI销售助手",
	// 	"show_content": [],
	// 	"style": "",
	// 	"show_style": "AI1"
	// },
	// {
	// 	"id":12,
	// 	"title":"AI售后助手",
	// 	"content":"AI售后助手",
	// 	"show_content":[],
	// 	"style":"",
	// 	"show_style":"AI3"
	// },
	// {
	// 	"id":11,
	// 	"title":"AI采购助手",
	// 	"content":"AI采购助手",
	// 	"show_content":[],
	// 	"style":"",
	// 	"show_style":"AI2"
	// },

	// {
	// 	"id":6,
	// 	"title":"AI扩图",
	// 	"content":"通过AI引擎可将上传图片进行扩充。",
	// 	"show_content":[],
	// 	"style":"",
	// 	"show_style":""
	// },
	// {
	// 	"id":7,
	// 	"title":"AI换装",
	// 	"content":"通过AI引擎实现AI换装。",
	// 	"show_content":[],
	// 	"style":"",
	// 	"show_style":""
	// },
	// {
	// 	"id":4,
	// 	"title":"软件-接口",
	// 	"content":"测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测",
	// 	"show_content":[],
	// 	"style":"",
	// 	"show_style":""
	// },{
	// 	"id":5,
	// 	"title":"软件产品-接口",
	// 	"content":"测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测",
	// 	"show_content":[],
	// 	"style":"",
	// 	"show_style":""
	// } 
]
let product_list_data_1 = [
	{
		"id": 1,
		"title": "离线AOI检测设备",
		"content": "一种用于自动检测平面物体表面缺陷和特征的光学设备，在电子制造等行业应用广泛。",
		"show_content": [
			"离线AOI检测设备是一种用于自动检测平面物体表面缺陷和特征的光学设备，在电子制造等行业应用广泛。",
			"利用光学成像系统采集被测物体的图像，然后通过图像处理算法对图像进行分析和处理，将采集到的图像与标准图像或设定的检测规则进行对比，从而识别出物体表面的缺陷，如元件缺失、偏移、极性错误、焊接不良等。",
			"应用领域广泛，例如电子制造行业中的印制电路板（PCB）的质量检测、半导体行业中芯片封装、晶圆表面等缺陷检测以及其他行业产品表面的划痕、裂纹、异物等缺陷。",
		],
		"style": "margin-left: 14px;",
		"show_style": "height: 280px;width: 320px;margin-top: 60px;margin-left:40px",
		"show_content_style": "",
		"unshow": false
	},
	// {
	// 	"id":2,
	// 	"title":"FEP-光纤端面研磨机",
	// 	"content":"FEP-光纤端面研磨机用于裸光纤端面研磨。",
	// 	"show_content":[
	// 		"FEP-光纤端面研磨机用于裸光纤端面研磨。",
	// 		"以微型独立研磨主机为主体，通过粗磨、细磨和抛光等多道抛磨工艺， 将光纤端面包层和纤芯研磨出不同角度的斜面和形状， 提高光学性能和可靠性。",
	// 		"设备配备分度圆调节角度， 外置千分尺调节光纤伸展角度和研磨压力。",
	// 		"快拆式裸纤适配器可夹持不同直径的光纤， 待磨光纤端面角度和形状可人为设定和控制。",
	// 		"适用于通讯器件特种光纤、医疗光纤、能量传输光纤端面异形研磨。"
	// 	],
	// 	"style":"",
	// 	"show_style":"height: 280px;width: 320px;margin-top: 60px;margin-left:40px",
	// 	"show_content_style":"width:600px;height: auto;margin-top: 10px;margin-bottom: 22px;line-height: 20px;"
	// },
	{
		"id": 16,
		"title": "底部加热膜AOI检测设备",
		"show_content": [
			"新能源电池加热膜缺陷检测设备是一款专为新能源汽车电池包加热膜片设计的高精度视觉检测设备。",
			"它致力于解决加热膜在生产过程中出现的各种微观缺陷，确保每一片出厂的加热膜都具备完美的电气安全性与热场均匀性，从源头上保障电池包的热管理安全和性能寿命。",
		],
		"style": "margin-top: 10px;margin-left: 14px;height: 180px;width: 200px;",
		"show_style": "height: 320px;width: 380px;margin-top: 40px;margin-left:10px",
		"show_content_style": ""
	},
	{
		"id": 17,
		"title": "平面AOI在线检测设备",
		"show_content": [
			"新能源电池加热膜缺陷检测设备是一款专为新能源汽车电池包加热膜片设计的高精度视觉检测设备平面AOI（Automated Optical Inspection）设备是一种用于自动检测平面物体表面缺陷和特征的光学设备。",
			"在电子制造等行业应用广泛，通常用于检测单个的平面物体，像平面电路板（PCB）、平面显示器、玻璃基板等。",
		],
		"style": "margin-top: 10px;margin-left: 14px;height: 180px;width: 200px;",
		"show_style": "height: 320px;width: 380px;margin-top: 40px;margin-left:10px",
		"show_content_style": ""
	},
	{
		"id": 4,
		"title": "卷对卷AOI缺陷检测设备",
		"content": "一种用于连续卷材状材料表面缺陷检测的自动化光学设备，在电子、包装、印刷等行业有着广泛应用。",
		"show_content": [
			"卷对卷AOI（Automated Optical Inspection）缺陷检测设备是一种用于连续卷材状材料表面缺陷检测的自动化光学设备，在电子、包装、印刷等行业有着广泛应用。",
			"设备利用光学系统对卷材表面进行实时成像，并将图像与预设标准或规则对比，从而准确检测出划痕、孔洞、污点、颜色偏差等缺陷。",
			"应用领域广泛，例如电子行业中检测柔性电路板、覆铜板等，包装行业检测塑料薄膜、纸张等包装材料，印刷行业检测印刷图案质量，如套印、缺印等",
			// "能够提高线路板的产品质量，为生产过程中的质量控制提供重要支持。"
		],
		"style": "margin-top: 10px;margin-left: 14px;height: 180px;width: 200px;",
		"show_style": "height: 290px;width: 380px;margin-top: 55px;margin-left:9px",
		"show_content_style": ""
	},
	{
		"id": 10,
		"title": "机械臂视觉检测设备",
		"content": "融合机械臂灵活运动与视觉检测高精度能力的自动化设备，主要用于工业生产中的质量检测和装配引导。",
		"show_content": [
			"机械臂视觉检测设备是融合机械臂灵活运动与视觉检测高精度能力的自动化设备，主要用于工业生产中的质量检测和装配引导。",
			"设备通过视觉系统采集图像并分析，获取物体特征信息。机械臂依据这些信息精确控制末端执行器，执行抓取、搬运、检测或装配等操作。",
			"应用领域广泛，例如工业自动化生产中用于汽车、电子设备制造等行业的零部件装配和质量检测，物流与仓储中实现货物自动分拣、码垛，机器人研究中作为机器人关键组件，用于环境感知和目标识别。"
		],
		"style": "margin-top: 10px;margin-left: 14px;height: 180px;width: 200px;",
		"show_style": "height: 290px;width: 370px;margin-top: 55px;margin-left:15px",
		"show_content_style": ""
	},
	{
		"id": 11,
		"title": "通用外观检测设备",
		"content": "通用外观检测设备是一种多行业适用的产品外观检测仪器，能够高效识别多种外观缺陷。",
		"show_content": [
			"通用外观检测设备是一种多行业适用的产品外观检测仪器，能够高效识别多种外观缺陷。",
			"设备基于光学成像原理，结合图像处理算法，采集并分析产品图像，与标准模型比对，识别缺陷如划痕、裂纹等。部分设备还融合激光、超声波技术，实现更全面的检测。",
			"应用领域广泛，例如电子行业中检测电子产品外壳、显示屏等，汽车行业中检测车身、发动机缸体等零部件，机械制造行业中检测各类机械零件。"
		],
		"style": "margin-top: 10px;margin-left: 14px;height: 180px;width: 200px;",
		"show_style": "height: 290px;width: 370px;margin-top: 55px;margin-left:15px",
		"show_content_style": ""
	},
	{
		"id": 12,
		"title": "在线检测设备",
		"content": "在线检测设备是生产线上实时检测产品并与其他设备协同工作的自动化装置，旨在提高生产效率和产品质量。",
		"show_content": [
			"在线检测设备是生产线上实时检测产品并与其他设备协同工作的自动化装置，旨在提高生产效率和产品质量。",
			"利用光学、电学、力学等多种检测技术，通过传感器实时采集产品数据，传输至控制系统进行分析处理，判断产品合格与否，并控制后续设备动作。",
			"应用领域广泛，例如食品饮料行业中检测产品包装完整性、液位和异物，制药行业中进行药品外观、装量和包装检测，电子制造行业中在线检测电路板、芯片等"
		],
		"style": "margin-top: 10px;margin-left: 14px;height: 180px;width: 200px;",
		"show_style": "height: 290px;width: 370px;margin-top: 55px;margin-left:15px",
		"show_content_style": ""
	},
	{
		"id": 14,
		"title": "红外视觉检测设备",
		"content": "红外视觉检测设备利用红外成像技术，通过捕捉物体发出的红外线来生成热图像，广泛应用于安防、工业和医疗等领域。",
		"show_content": [
			"红外视觉检测设备利用红外成像技术，通过捕捉物体发出的红外线来生成热图像，广泛应用于安防、工业和医疗等领域。",
			"设备通过红外探测器接收物体红外线，转化为电信号后经处理重建为热图像。图像中不同灰度或颜色代表不同温度，从而检测物体温度分布和缺陷。",
			"应用领域广泛，例如安防监控中夜间或恶劣天气下监控，工业检测中检测电气过热、管道泄漏、建筑缺陷等，医疗诊断中检测人体表面温度分布，辅助诊断疾病如乳腺癌、血管疾病等。"
		],
		"style": "margin-top: 10px;margin-left: 14px;height: 180px;width: 200px;",
		"show_style": "height: 290px;width: 370px;margin-top: 55px;margin-left:15px",
		"show_content_style": ""
	},
	{
		"id": 13,
		"title": "精密检测设备",
		"content": "精密检测设备包括多种类型，专门用于高精度尺寸测量、形状检测和表面质量分析，广泛应用于多个行业。",
		"show_content": [
			"精密检测设备包括多种类型，专门用于高精度尺寸测量、形状检测和表面质量分析，广泛应用于多个行业。",
			"光学显微镜：用于电子、机械制造等行业，检测表面粗糙度、划痕、裂纹，及尺寸测量和形状分析。",
			"三坐标测量仪：用于汽车、航空航天等领域，测量复杂形状零件如发动机叶片、精密齿轮。",
			"激光测径仪：用于电子、电线电缆行业，测量微小直径零件如电子元器件引脚、电线直径。"
		],
		"style": "margin-top: 10px;margin-left: 14px;height: 180px;width: 200px;",
		"show_style": "height: 290px;width: 370px;margin-top: 55px;margin-left:15px",
		"show_content_style": ""
	},
	{
		"id": 3,
		"title": "电子产品老化监控设备",
		"content": "电子产品老化监控设备是一种用于评估电子产品出厂前的性能标准和可靠性的测试系统。",
		"show_content": [
			"电子产品老化监控设备是一种用于评估电子产品出厂前的性能标准和可靠性的测试系统。",
			"本系统支持对大功率电子产品进行7*24小时长时间老化测试及监控。",
			"采取模块化设计，适配性高，散热性好，老化异常可自动断电保护。"
		],
		"style": "margin-top: 10px;margin-left: 14px;height: 180px;width: 200px;",
		"show_style": "height: 300px;width: 300px;margin-top: 50px;margin-left:50px",
		"show_content_style": ""
	},
	{
		"id": 8,
		"title": "光纤端检仪",
		"content": "提供多种光纤端面检测清洁解决方案，有效的提升产品质量及可靠性。",
		"show_content": [
			"提供多种光纤端面检测清洁解决方案，有效的提升产品质量及可靠性。",
			"采用全自动智能化的设计和高清的光学系统，实现快速全自动的检测端面缺陷，确保产品的可靠性；高效的控制产品质量。"

		],
		"style": "margin-top: 10px;margin-left: 15px;height: 180px;width: 200px;",
		"show_style": "height: 280px;width: 320px;margin-top: 60px;margin-left:40px",
		"show_content_style": ""
	},
	{
		"id": 9,
		"title": "数码显微镜",
		"content": "数码显微镜在产业中替代传统显微镜，执行微观场景的样本观察、记录和分析动作。",
		"show_content": [
			"数码显微镜在产业中替代传统显微镜，执行微观场景的样本观察、记录和分析动作。",
			"我们提供多种不同用途的数码显微镜，内置的摄像头起到检测器的作用，除了显示高分辨率的放大图像外，还支持客户定制所需的检测功能。"

		],
		"style": "margin-top: 10px;margin-left: 14px;height: 180px;width: 200px;",
		"show_style": "height: 320px;width: 380px;margin-top: 40px;margin-left:10px",
		"show_content_style": ""
	},
	{
		"id": 15,
		"title": "光学筛选机",
		"show_content": [
			"光学筛选机是一种利用光学原理进行物料筛选的设备，广泛应用于电子、半导体、光学、精密机械等行业。",
			"它通过高分辨率的光学系统，对物料进行精细的视觉检测和分类，确保产品质量和生产效率。",
			"光学筛选机具有高精度、高效率、自动化程度高等特点，是现代工业生产中不可或缺的重要设备。"
		],
		"style": "margin-top: 10px;margin-left: 14px;height: 180px;width: 200px;",
		"show_style": "height: 320px;width: 380px;margin-top: 40px;margin-left:10px",
		"show_content_style": ""
	},
	{
		"id": 18,
		"title": "饮品密封检测设备",
		"show_content": [
			"饮品密封检测设备是一种专门用于检测瓶装、罐装等饮品包装密封性的关键设备，广泛应用于饮料、乳制品、制药、化妆品等行业。",
			"它通过高精度传感器和先进的检测技术（如压力衰减、真空测试、激光或视觉成像），对产品封口处进行非破坏性或破坏性的精密检测，确保包装的完整性与安全性。",
			"饮品密封检测设备具有高灵敏度、高自动化、检测速度快、结果可追溯等特点，是保障产品质量、延长货架寿命和维护品牌声誉的必备质量控制设备。"
		],
		"style": "margin-top: 10px;margin-left: 14px;height: 180px;width: 200px;",
		"show_style": "height: 320px;width: 380px;margin-top: 40px;margin-left:10px",
		"show_content_style": ""
	},
	{
		"id": 19,
		"title": "一键尺寸测量设备",
		"show_content": [
			"一键尺寸测量设备是一种集成了先进机器视觉与精密传感技术的自动化检测设备，专为快速、准确地获取工件的三维尺寸而设计，广泛应用于电子制造、汽车零部件、精密注塑、医疗器械和质量控制等领域。",
			"它通过高分辨率工业相机、结构光或激光扫描技术，结合智能图像处理算法，仅需一次按键即可在数秒内完成对复杂工件的全方位尺寸测量，包括长度、宽度、高度、直径、角度、R角等多种几何参数，无需人工干预。",
			"一键尺寸测量设备具有测量精度高、重复性好、操作简便、检测效率极高等特点，能够有效替代传统卡尺、投影仪等手动测量工具，是提升生产效率、保证产品一致性和实现智能化质量管控的关键设备。"
		],
		"style": "margin-top: 10px;margin-left: 14px;height: 180px;width: 200px;",
		"show_style": "height: 320px;width: 380px;margin-top: 40px;margin-left:10px",
		"show_content_style": ""
	}
]


let product_list_data_2 = [
	{
		"id": 8,
		"title": "AOI检测系统",
		"content": "通过光学设备获取图像并进行分析判断，广泛应用于电子制造、汽车制造和机械加工等行业",
		"show_content": [
			"专为AOI设备设计的测量系统，拥有自主知识产权。它通过光学设备获取图像并进行分析判断，广泛应用于电子制造、汽车制造和机械加工等行业",
			"能识别细微缺陷，如电子元件裂纹、虚焊等，测量精度可达0.001mm",
			"短时间內完成大量产品检测，提高生产效率，具备快速编程和自动调整功能",
			"根据不同检测任务和场景，灵活选择算法和光学系统，软件模块化设计便于灵活调用",

		],
		"style": "margin-top: 10px;margin-left: 14px;height: 180px;width: 200px;",
		"show_style": "height: 280px;width: 300px;margin-top: 55px;margin-left:45px",
		"show_content_style": ""
	},
	{
		"id": 9,
		"title": "储能电池监控系统",
		"content": "储能电池监控系统一种用于监测和管理储能电池组运行状态的设备或系统。",
		"show_content": [
			"储能电池监控系统是一种用于监测和管理储能电池组运行状态的设备或系统。它拥有数据采集、状态监测、安全保护、能量管理等功能，组成部分有传感器、数据采集单元、监控主机和通信网络。",
			"在太阳能、风能等发电系统中，监测管理储能电池，保障发电稳定可靠，实现能源有效存储和利用。",
			"在智能电网系统中，协助电网运营商优化电力分配，提升电网灵活性和可靠性，实现削峰填谷、调频调压等关键功能。",
			"在电动汽车充电系统中，监控充电站内的储能电池，提高充电效率，保障安全，并实现与电网的互动，降低对电网的影响。"
		],
		"style": "margin-top: 10px;margin-left: 14px;height: 180px;width: 200px;",
		"show_style": "height: 280px;width: 300px;margin-top: 55px;margin-left:45px",
		"show_content_style": ""
	},
	{
		"id": 10,
		"title": "企业信息系统",
		"content": "主要用于对企业的各种信息进行收集、存储、处理、传输和共享，以支持企业的管理、决策和业务运作。",
		"show_content": [
			"企业信息系统是一个综合人机交互平台，集成了计算机硬件、软件、网络通信及办公设备，旨在收集、存储、处理、传输和共享企业信息，以提升管理、决策和业务运作效率。",
			"此系统拥有数据处理、业务流程自动化、信息共享和沟通以及决策支持等功能，涵盖了MES即制造执行系统（Manufacturing Execution System）、企业资源规划（ERP）系统、客户关系管理（CRM）系统和供应链管理（SCM）系统。"
		],
		"style": "margin-top: 10px;margin-left: 15px;height: 180px;width: 200px;",
		"show_style": "height: 280px;width: 300px;margin-top: 55px;margin-left:45px",
		"show_content_style": ""
	},
	{
		"id": 1,
		"title": "电力应急设备库存跟踪监控",
		"content": "通过计算机视觉和物联网技术实现对供电应急设备仓库的智能化管理。",
		"show_content": [
			"通过计算机视觉和物联网技术实现对供电应急设备仓库的智能化管理。",
			"进行实时库存统计，自动更新库存信息，避免人工盘点误差，确保库存数据的准确性和及时性。",
			"可用于库存管理、电力设备库房管理、电力应急设备跟踪。",
			// "摄像头：用于实时监控仓库中的设备借还行为，并拍摄工作人员的操作过程。",
			// "数据库系统：用于存储设备信息、工作人员身份信息及库存状态。",
			"后端系统：负责设备的管理和库存状态的实时更新。",
			"前端系统：提供给管理员的用户界面，用于查看实时库存状态、设备借还记录等。"
		],
		"style": "",
		"show_style": "height: 280px;width: 320px;margin-top: 60px;margin-left:40px",
		"show_content_style": "",
		// "show_content_style":"width: 550px;"

	}, {
		"id": 2,
		"title": "光束成像设备",
		"content": "光束成像设备用于产品的质量控制和性能评估测量和分析激光束的空间光斑质量、光强分布、光束发散度等参数。",
		"show_content": [
			"光束成像设备用于产品的质量控制和性能评估测量和分析激光束的空间光斑质量、光强分布、光束发散度等参数，确保产品的质量和性能符合标准要求。",
			"提供关于激光束的尺寸、形状、模式等详细信息，辅助用户调整和优化产品的参数，提高产品的效率和性能。"
		],
		"style": "",
		"show_style": "height: 320px;width: 320px;margin-top: 35px;margin-left:35px",
		"show_content_style": ""
	}, {
		"id": 3,
		"title": "飞参识别系统",
		"content": "用于各类模拟飞机仪表盘飞行参数提取。",
		"show_content": [
			"用于各类模拟飞机仪表盘飞行参数提取。",
			"对P3D、X-plane、DCS world和Microsoft Flight Simulator的飞行训练模拟数据的读取。",
			"可以选择本地mp4文件，摄像头IP端口的视频流以及网络视频流实现实时在线检测。",
			"将视频流输入分割为一帧一帧的图像，放入到YOLO实时目标检测模型中进行仪表定位。",
			"对定位到的仪表进行截取，然后输入到PaddleOCR字符识别模型中对仪表内容进行识别。"
		],
		"style": "margin-top: 10px;margin-left: 14px;height: 180px;width: 200px;",
		"show_style": "height: 280px;width: 320px;margin-top: 60px;margin-left:40px",
		"show_content_style": ""
	},
	{
		"id": 5,
		"title": "条形码识别软件",
		"content": "通过视觉软件识别出微型管状产品的字符串 ，字母加数字组合的字符串可以准确识别出来，能够自动记录到系统中。",
		"show_content": [
			"通过视觉软件识别出微型管状产品的字符串 ，字母加数字组合的字符串可以准确识别出来，能够自动记录到系统中。",
			" 在零售、物流、制造业等多个行业中，条码图像处理及识别软件得到了广泛应用。",
			"从商品入库、库存管理到销售结算，条码识别技术为自动化和信息化的实现提供了技术支持，大大提高了效率。"

		],
		"style": "margin-top: 10px;margin-left: 14px;height: 180px;width: 200px;",
		"show_style": "height: 360px;width: 380px;margin-top: 20px;margin-left:10px",
		"show_content_style": ""
	},
	{
		"id": 4,
		"title": "光纤端面成像和识别",
		"content": "通过机械视觉从侧面得到的光纤图像中识别产品端面是否平整，判断产品是否合格。",
		"show_content": [
			"左图是光纤的示意图。",
			"光纤包括包层3、应力区2、纤芯1，所述纤芯1位于包层3的中心，所述应力区2，对称设置在纤芯1的两侧且位于包层3中。",
			"这种光纤具有制作工艺成熟和产品性能一致的优点，因此正被广泛应用于光纤通信、光纤激光以及光纤传感等系中。"

		],
		"style": "margin-top: 10px;margin-left: 14px;height: 180px;width: 200px;",
		"show_style": "height: 280px;width: 300px;margin-top: 55px;margin-left:45px",
		"show_content_style": ""
	},
	{
		"id": 6,
		"title": "监控云平台",
		"content": "适用于各种应用场景，同时可赋能第三方硬件、算法、平台厂商，实现生态与发展共赢。",
		"show_content": [
			"适用于公安、政法、检察院、综治、政府、企业、校园、社区、工地、银行、能源、交通、电力等行业，同时可赋能第三方硬件、算法、平台厂商，实现生态与发展共赢。",
			"通过整合异构品牌厂家视频、图像、信令等感知数据，依托先进的AI 算法，提供实时视频、历史视频、电子地图、人车档案、人车布控、事件预警、物联感知、工单运维、统计分析等功能，为用户提供清晰、安全、灵活、高效的应用软件平台。"
		],
		"style": "margin-top: 10px;margin-left: 14px;height: 180px;width: 200px;",
		"show_style": "height: 280px;width: 300px;margin-top: 55px;margin-left:45px",
		"show_content_style": ""
	},
	{
		"id": 7,
		"title": "定制软件、系统",
		"content": "定制化软件、系统开发。AI识别、图像处理算法研发",
		"show_content": [
			"特种设备运动控制软硬件定制",
			"定制化网站建设",
			"定制化APP软件开发",
			"定制化微信小程序开发",
			"特殊图像识别算法定制",
			"生产线自动化软件定制",
			"远程实施、部署..."


		],
		"style": "margin-top: 10px;margin-left: 14px;height: 180px;width: 200px;",
		"show_style": "height: 280px;width: 300px;margin-top: 55px;margin-left:45px",
		"show_content_style": ""
	},


]

let product_list_data_3 = [
	{
		"id": 7,
		"title": "机械臂视觉检测设备",
		"content": "机械臂视觉检测设备是一种结合了机械臂的运动灵活性和视觉检测系统的高精度检测能力的自动化设备",
		"show_content": [
			"机械臂视觉检测设备是一种结合了机械臂的运动灵活性和视觉检测系统的高精度检测能力的自动化设备。",
			"实现对产品外观的高精度缺陷检测，能够在短时间内完成大量的检测任务并剔除不合格产品。",
			"替代传统人工检测实现100%检测，设备使用后生产效率提高30%，能够24小时不间断工作，最大程度保证了工业生产中的生产效率和产品质量。"
		],
		"style": "margin-top: 10px;margin-left: 15px;height: 180px;width: 200px;",
		"show_style": "height: 300px;width: 320px;margin-top: 42px;margin-left:37px",
		"show_content_style": ""
	},
	{
		"id": 8,
		"title": "AOI检测设备",
		"content": "AOI检测设备一种用于自动检测平面物体表面缺陷和特征的光学设备，在电子制造等行业应用广泛。",
		"show_content": [
			"平面AOI（Automated Optical Inspection）检测设备是一种用于自动检测平面物体表面缺陷和特征的光学设备，在电子制造等行业应用广泛。",
			"利用光学成像系统采集被测物体的图像，然后通过图像处理算法对图像进行分析和处理，将采集到的图像与标准图像或设定的检测规则进行对比，从而识别出物体表面的缺陷，如元件缺失、偏移、极性错误、焊接不良等。",
			"应用领域广泛，例如电子制造行业中的印制电路板（PCB）的质量检测、半导体行业中芯片封装、晶圆表面等缺陷检测以及其他行业产品表面的划痕、裂纹、异物等缺陷。",
		],
		"style": "margin-top: 10px;margin-left: 15px;height: 180px;width: 200px;",
		"show_style": "height: 300px;width: 320px;margin-top: 42px;margin-left:37px",
		"show_content_style": ""
	},
	{
		"id": 9,
		"title": "通用外观检测设备",
		"content": "通过自动记录检测数据和图像便于进行数据统计、分析和追溯，能够为生产工艺改进、产品质量提升提供有力依据。",

		"show_content": [
			"基于光学成像原理，通过相机采集产品外观图像，然后运用图像处理算法对图像进行分析处理，与预设的标准图像或特征模型进行比对，从而识别出产品外观存在的缺陷，如划痕、裂纹、孔洞、变形、表面污渍等。",
			"完全替代传统人工质检，降低人工成本提升检测速度及精度，通过自动记录检测数据和图像便于进行数据统计、分析和追溯，能够为生产工艺改进、产品质量提升提供有力依据。"
		],
		"style": "margin-top: 10px;margin-left: 15px;height: 180px;width: 200px;",
		"show_style": "height: 300px;width: 320px;margin-top: 42px;margin-left:37px",
		"show_content_style": ""
	},
	{
		"id": 10,
		"title": "在线检测设备",
		"content": "在线检测设备是一种在生产线上实时对产品进行检测，并能与其他生产设备协同工作的自动化检测装置。",
		"show_content": [
			"在线检测设备是一种在生产线上实时对产品进行检测，并能与其他生产设备协同工作的自动化检测装置。",
			"该设备对生产线上连续运动的产品进行快速、实时检测，通过传感器采集产品的相关数据，将其传输至控制系统，控制系统依据预设的标准和算法对数据进行分析处理，判断产品是否合格，并及时发出指令控制后续设备的动作。",
			"设备加入产线后可实现从检测、分析、处理完全自动化，为企业构建完整的信息化生态系统，打造无人工厂智能制造，提高生产效率。"
		],
		"style": "margin-top: 10px;margin-left: 15px;height: 180px;width: 200px;",
		"show_style": "height: 300px;width: 320px;margin-top: 42px;margin-left:37px",
		"show_content_style": ""
	},
	{
		"id": 3,
		"title": "智能化巡检机器人",
		"content": "解决传统人工巡检作业效率低、检测质量分散、手段单一、设备全生命周期管理等问题。",
		"show_content": [
			"可使用智能化巡检机器人进行全天候监测配电房内仪表设备状态和数据，解决传统人工巡检效率低、检测质量分散、手段单一、设备全生命周期管理等问题。",
			"替代传统人工管理人员低效率、易漏检的安全管理操作。",
			"避免高压电的接触可能导致严重的电击伤害，避免电气设备过热或短路可能导致的火灾。",
			// "避免电气设备过热或短路可能导致火灾。",
			"避免电力设备的短路或漏电可能导致触电事故，避免皮带输送机、抓斗机等设备卷入人员。",
			// "避免皮带输送机、抓斗机等设备卷入人员"
		],
		"style": "width: 200px;margin-left: 15px;",
		"show_style": "height: 280px;width: 320px;margin-top: 60px;margin-left:40px",
		"show_content_style": ""
	},
	{
		"id": 4,
		"title": "防尘盖上料检测设备",
		"content": "通过视觉识别检测防尘盖底部测是否缺失、是否撕膜以及是否溶胶等。",
		"show_content": [
			"使用下相机拍摄防尘盖的底部进行定位，再使用上相机拍摄血糖仪零件，如果零件不完整，则进行剔除，并进行补料。如果完整的话，就将防尘盖盖到血糖仪上面，进行防尘处理。",
			"通过视觉识别检测防尘盖底部测是否缺失、是否撕膜以及是否溶胶等，确保产品质量。",

		],
		"style": "margin-top: 0px;margin-left: 35px;height: 210px;width: 180px;",
		"show_style": "height: 340px;width: 330px;margin-top: 10px;margin-left:40px",
		"show_content_style": ""
	},
	{
		"id": 5,
		"title": "镜筒压环缺陷检测设备",
		"content": "通过视觉识别检测镜筒点胶后胶路是否有溢胶，漏胶，胶洞等缺陷。",
		"show_content": [
			"镜筒点胶的主要目的是确保镜头的稳固安装和密封性，从而提高镜头的光学性能和可靠性。",
			"点胶后胶路的状态会直接影响该性能，通过视觉检测检测点胶后胶路是否有溢胶，漏胶，胶洞等缺陷，确保产品质量。",

		],
		"style": "margin-top: 10px;margin-left: 15px;height: 180px;width: 200px;",
		"show_style": "height: 300px;width: 320px;margin-top: 42px;margin-left:37px",
		"show_content_style": ""
	},
	{
		"id": 6,
		"title": "电池仓异物检测设备",
		"content": "通过视觉识别检测电池仓中是否存在螺丝、残渣、保护膜、玻璃纸等异物散落在电池仓内。",
		"show_content": [
			"通过视觉识别检测电池仓中是否存在螺丝、残渣、保护膜、玻璃纸等异物散落在电池仓内。",
			"对电池仓内高度突变小的特征和突变大的异物做区分，有效实现异物检出。"

		],
		"style": "margin-top: 10px;margin-left: 15px;height: 180px;width: 200px;",
		"show_style": "height: 300px;width: 320px;margin-top: 42px;margin-left:37px",
		"show_content_style": ""
	},
	{
		"id": 1,
		"title": "AI识别预警系统",
		"content": "实现对园区厂房潜在问题的实时监控和预警，提高运营效率，保障人员安全，降低事故风险。",
		"show_content": [
			"针对园区厂房电力系统故障、设备故障、火灾隐患，可以使用配置智能化的AI识别预警系统。",
			"通过AI识别预警系统，能够实现对这些潜在危险的实时监控和预警，提高运营效率，保障人员安全，降低事故风险。"

		],
		"style": "",
		"show_style": "height: 280px;width: 320px;margin-top: 60px;margin-left:40px",
		"show_content_style": ""
	}, {
		"id": 2,
		"title": "车辆智能化管理系统",
		"content": "实现对厂区车辆的高效、安全和智能管理，提高运营效率，降低运营成本。",
		"show_content": [
			"在复杂环境对车牌进行高精度实时识别、响应。",
			"车辆智能化管理系统，够实现对车辆的高效、安全和智能管理，提高运营效率，降低运营成本。",
			"车牌识别精准度高，确保数据的隐私性和合规性。"
		],
		"style": "",
		"show_style": "height: 280px;width: 320px;margin-top: 60px;margin-left:40px",
		"show_content_style": ""
	},
]

let product_list_data_4 = [
	{
		"id": 1,
		"title": "消费电子",
		"content": "消费电子行业存在大量定制化订单，同一条生产线上会频繁切换不同品牌、不同型号的产品，并且材质多种多样，包括塑料、金属、玻璃等，为之易自主研发的AI视觉检测算法，能够针对行不同产品特性快速生成检测模型，广泛用于各类消费电子的视觉检测，对于确保产品质量、提升生产效率具有重要意义。",
		"show_list": [
			{
				"title": "FPC软板",
				"introduce_text": "FPC软板因其轻薄、可弯曲的特性，在生产过程中容易出现各种微小瑕疵，为之易AI视觉检测系统能够实现对这些微小瑕疵的高精度检测，确保产品质量符合设计要求。",
				"ability_text": "用于检测FPC软板上的划痕、断裂、污染、焊点不良等多种瑕疵和缺陷。"
			},
			{
				"title": "Type-C连接器",
				"introduce_text": "Type-C连接器广泛应用于手机、笔记本电脑等电子设备中，其特点包括小型化、纤薄化，通过为之易视觉AI云服务平台快速生成检测模型，对Type-C连接器进行高精度视觉检测。",
				"ability_text": "用于检测Type-C连接器表面粉屑压伤、划伤、金手指变形、料桥压伤、模印、毛边等缺陷;Type-C连接器外壳变形、压伤、划伤等缺陷。"
			},
			{
				"title": "手机镜头",
				"introduce_text": "手机镜头具有表面反光、缺陷类型多样且微小等特点，为之易针对此类情况研发的AI视觉智能算法可以对镜头进行高精度检测，以满足现代手机镜头制造的需求。",
				"ability_text": "用于检测手机镜头字体偏位、透光、白点、黑点、划伤、毛丝、崩缺、卷边等缺陷。"
			},
			{
				"title": "手机内部",
				"introduce_text": "手机内部视觉缺陷检测是确保手机产品质量的重要环节，通过为之易AI视觉检测算法可以实现对手机内部部件和组件的准确、高效和全面检测。",
				"ability_text": "用于检测主板上的焊接缺陷、元器件缺失或损坏、线路破损;手机内部螺丝缺失、多余。"
			},
			{
				"title": "手机整机",
				"introduce_text": "手机外观缺陷种类繁多、复杂，检测精度要求高，为之易AI视觉云服务平台，可以针对不同手机型号训练生成对应的检测模型，对各类手机外观进行全面检测。",
				"ability_text": "用于检测屏幕外观划痕、污垢、亮点、暗点、花屏等;背板划伤、凹陷、脏污、电镀掉漆、异色等;边框变形、缺口、划痕等。"
			},
			{
				"title": "笔记本电脑内部",
				"introduce_text": "笔记本电脑内部集成度高，背景复杂，为之易AI视觉检测算法算法具有高度的通用性和灵活性，可以对其内部缺陷进行精准识别。",
				"ability_text": "用于检测笔记本电脑内部焊接点漏焊、虚焊、连焊；内部组件错位、缺失。"
			},
			{
				"title": "笔记本电脑外观",
				"introduce_text": "针对笔记本整机产品面积较大、缺陷位置随机、种类多样等特点，为之易采用传统算法+深度学习算法相结合的方式，将其外观瑕疵进行定位识别，实现高效、准确的缺陷检。",
				"ability_text": "用于检测笔记本电脑内部焊接点漏焊、虚焊、连焊;内部组件错位、缺失。"
			},
			{
				"title": "服务器/工控机整机",
				"introduce_text": "服务器内部和外部环境可能包含复杂的背景和干扰因素，通过为之易视觉AI云服务平台训练生成对应的检测模型，可以大幅度提高服务器视觉检测精度和效率，有效识别各类瑕疵。",
				"ability_text": "用于检测服务器外壳划痕、凹陷、变形;内部组件损坏、烧焦、变形、缺失。"
			},
			{
				"title": "遥控器键盘",
				"introduce_text": "遥控器键盘按键通常较小，且可能存在反光、阴影等问题，采用为之易高精度AI视觉检测算法可以对微小瑕疵准确识别，能够及时发现潜在问题，减少不良品的流出。",
				"ability_text": "用于检测遥控器键盘字符缺损、模糊、错位;按键偏移;外观划痕、凹陷、污渍等。"
			},
			{
				"title": "透镜外观",
				"introduce_text": "由于透镜表面的反射和散射现象，缺陷的识别和测量也变得更加复杂和困难，为之易AI视觉检测算法凭借自身优异的算法，可以根据样本训练生成高精度检测模型，对透镜进行全面检测，保障其产出质量。",
				"ability_text": "用于检测透镜表面气泡、裂纹、粘料、脏污、球面划痕、球破损。"
			},
			{
				"title": "磁瓦外观",
				"introduce_text": "磁瓦表面的细微瑕疵导致人工检测的工作强度大，误检率高，应用为之易人工智能视觉检测算法对磁瓦进行高精度、高强度检测，可以有效避免人工检测带来的误差，大大提高检效率。",
				"ability_text": "用于测量磁瓦长度、宽度、厚度等尺寸;检测磁瓦表面裂纹、麻点、崩烂、掉角等。"
			},

		],
	},
	{
		"id": 2,
		"title": "半导体",
		"content": "半导体行业是一个要求高精度、高功率、零误差的行业，产品尺寸微小、形状复杂，普通检测技术难以满足其检测需求，依托为之易系列产品，通过先进的图像处理算法和深度学习技术，能够精准捕捉和分析各类表面的微小缺陷，实现高精度、高效率的自动化检测。",
		"show_list": [
			{
				"title": "晶圆",
				"introduce_text": "晶圆是半导体产业的基础，其检测项目繁多且复杂，为之易基于AI算法能精准捕捉晶圆表面划痕、裂纹等缺陷，提升检测精度与效率。",
				"ability_text": "用于检测划痕、裂纹、污染等缺陷。"
			},
			{
				"title": "电容",
				"introduce_text": "电容外观检测难点在于微小裂纹、锈迹等多样缺陷难以察觉且标准严苛。为之易技术凭借机器视觉AI算法，针对性识别电容独特外观缺陷，实现高效精准检测。",
				"ability_text": "用于检测微小裂纹、锈迹、划痕、污渍等缺陷。"
			},
			{
				"title": "TEC组件",
				"introduce_text": "在半导体制造过程中，TEC组件的外观缺陷如划痕、凹凸、破损、裂痕、气孔、异物、污染等都可能导致TEC组件在工作过程中出现故障或性能下降。为之易技术赋能，运用机器视觉技术精准捕捉电池表面瑕疵，大幅提升检测精度。",
				"ability_text": "用于检测微小裂纹、锈迹、划痕、污渍等缺陷。"
			},
			{
				"title": "纽扣电池",
				"introduce_text": "纽扣电池的质量直接影响电路性能与安全性，检测过程中面临微小缺陷难以察觉等难点。为之易技术赋能，运用机器视觉技术精准捕捉电池表面瑕疵，大幅提升检测精度。",
				"ability_text": "用于检测划痕、裂纹、锈斑、凹点、污脏、光面、异色等缺陷。"
			},
			{
				"title": "半导体晶粒",
				"introduce_text": "晶粒在制造过程中可能会产生划痕、凹凸、破损、裂痕、气孔、异物、污染等外观缺陷。为之易技术赋能，运用机器视觉技术精准捕捉表面瑕疵，大幅提升检测精度。",
				"ability_text": "用于检测残粒、脏污、掉镀层、缺损、异物等缺陷。"
			},
			{
				"title": "芯片键合线",
				"introduce_text": "依托为之易机器视觉技术，通过深度学习算法，非破坏性识别微米级缺陷，如导线下垂、近短路，确保连接可靠性，为半导体制造提供坚实质量保障。",
				"ability_text": "用于检测来料不良、断线、少线、乱线、框架划痕、异物等缺陷。"
			},
			{
				"title": "芯片",
				"introduce_text": "芯片尺寸微小，传统的人工检测方法受限于人的视觉分辨率和疲劳度，难以长时间保持高精度和高效率。为之易的视觉AI检测技术结合了先进的图像处理算法和深度学习技术，能够实现对芯片外观缺陷的精准识别。",
				"ability_text": "用于检测脏污、麻点、破损、缺角、异物、原件缺失，错位、划伤等缺陷。"
			},
			{
				"title": "PCB板",
				"introduce_text": "PCB板外观缺陷检测，面临铜箔暴露、线路断裂、焊点不良等多样挑战。为之易视觉AI技术，针对PCB板特性，基于深度学习算法，精准识别微小缺陷，满足半导体行业对PCB外板观质量的严格要求。",
				"ability_text": "用于检测锡膏残留，Pad 脏污、划伤、漏铜、极性角残留，激光分板漏铜等缺陷。"
			},
			{
				"title": "基板",
				"introduce_text": "电子陶瓷片、铜片、钨片等基板材料是电子元器件的重要载体，为之易基于AI技术能自动检测缺陷、测量尺寸，显著提升检测效率与准确率，确保产品质量，降低不良率。",
				"ability_text": "用于检测基板表面脏污、破损、划痕、长宽尺寸，一点至多点厚度等。"
			},
			{
				"title": "PIN针",
				"introduce_text": "PIN针检测面临弯曲、断裂、氧化等挑战。为之易视觉AI技术，针对PIN针特点，运用深度学习算法，精确捕捉微小缺陷，确保电子元器件PIN针外观质量符合行业高标准，提升整体设备的性能与可靠性。",
				"ability_text": "针对PIN针的形状、尺寸、位置、是否歪斜、表面缺陷等进行实时、准确的检测。"
			},
			{
				"title": "电阻器",
				"introduce_text": "电阻器检测面临阻值偏差、表面破损、引脚缺陷等挑战。为之易视觉AI技术，针对电阻器特性，运用深度学习算法，精确识别细微问题，确保电子元器件电阻器质量达标，满足电子行业对高性能元件的严格需求。",
				"ability_text": "用于检测锡膏残留，Pad 脏污、划伤、漏铜、极性角残留，激光分板漏铜等缺陷。"
			},
			{
				"title": "电感器",
				"introduce_text": "电感器检测面临绕线松散、磁芯裂纹、引脚弯折等挑战。为之易视觉AI技术，针对电感器特性，采用深度学习算法，精准捕捉微小瑕疵，确保电子元器件电感器质量过硬，满足电子行业对电感器外观及性能的严苛标准。",
				"ability_text": "用于检测电感器线圈断裂、变形、排列不整齐、封装存在裂缝等缺陷。"
			},
			{
				"title": "连接器",
				"introduce_text": "连接器检测面临引脚歪斜、接触不良、绝缘体破损等挑战。为之易视觉AI技术，针对连接器特性，运用深度学习算法，精准识别微小瑕疵，确保电子元器件连接器质量达标，满足电子行业对连接器外观及连接性能的严格要求。",
				"ability_text": "用于检测歪曲、断裂、变形、污染等缺陷。"
			},
			{
				"title": "LED",
				"introduce_text": "LED外观检测面临灯珠缺失、颜色不均、封装破损等挑战。为之易视觉AI技术，针对LED特性，运用深度学习算法，精准识别细微瑕疵，确保电子元器件LED外观质量卓越，满足照明及显示行业对LED器件的高标准要求。",
				"ability_text": "用于检测气泡、检测气泡、胶裂等关键缺陷。"
			},
			{
				"title": "端子",
				"introduce_text": "端子主要作用是导电或传递电信号，其产品质量至关重要，传统的人工检测方式难以满足现代化高质量产品的需求，采用为之易AI视觉检测技术对端子进行视觉检测，可以全面检测出其出厂前可能会出现的瑕疵，有效提升提高产品出厂质量。",
				"ability_text": "用于检测端子表面毛刺、划痕、缺损、脏污、变形、凹凸不平、尺寸偏差等。"
			},
			{
				"title": "陶瓷片",
				"introduce_text": "陶瓷片尺寸小、瑕疵细微且表面反光，为之易人工智能视觉检测算法可以根据陶瓷片的外观特性训练并生成检测模型，对陶瓷片进行精准检测，确保其检测结果的有效性和可靠。",
				"ability_text": "用于测量陶瓷片长度、宽度、厚度;检测陶瓷片表面变形、裂纹、破损、擦伤、污渍等。"
			},
			{
				"title": "贴装锡点",
				"introduce_text": "贴装锡点存在于各类元器件的连接部位，其质量直接关系到设备的正常运行，为之易AI视觉检测技术可以对锡点瑕疵进行全面检测，为设备正常运行提供强有力的保障。",
				"ability_text": "用于检测表面锡点缺失、异物、用量、形状等。"
			},
		]
	},
	{
		"id": 3,
		"title": "新能源",
		"content": "新能源行业正处于高速发展的阶段，产品尺寸多变、工艺迭代速度快，这对视觉检测算法的效率和精度提出了更高的要求，为之易自主研发的AI视觉检测算法能够适应不断变化的产品标准和高速度、高精度的检测需求，为新能源行业提供更加高效、准确和稳定的检测手段。",
		"show_list": [
			{
				"title": "太阳能电池板",
				"introduce_text": "太阳能电池板种类规格繁多，其表面可能存在反光、阴影、缺陷微小等情况，为之易采用先进的机器学习和深度学习算法提高算法的适应性和泛化能力，使其能够自动适应不同类型的缺陷。",
				"ability_text": "用于检测太阳能电池板表面划痕、变形、脱漆、毛刺;电池片损伤、裂缝、烧结、锈蚀;边框裂缝、变形。"
			},
			{
				"title": "太阳能硅片",
				"introduce_text": "太阳能硅片表面反光强烈，使得特征提取和分类面临难题，传统的机器视觉检测方法在某些情况下可能无法满足要求。通过为之易视觉AI云服务平台训练生成检测模型可以检测硅片生产过程中的各个关键质量指标，确保硅片质量得到全面把控。",
				"ability_text": "用于检测硅片的尺寸、厚度、倒角、崩边、脏污、隐裂、杂质。"
			},
			{
				"title": "电池极片",
				"introduce_text": "电池极片的制造精度要求非常高。为之易AI视觉检测算法凭借自身的优势，能够以高速且高精度地对电池极片进行检测，相比传统的人工巡检方式，大大提高了检测效率和准确性。",
				"ability_text": "用于检测极片表面凹陷、突起、断裂、裂纹、异物、杂质、表面不平整、气泡、空洞以及对于长度、高度、宽度等尺寸的测量。"
			},
			{
				"title": "电芯",
				"introduce_text": "电芯表面缺陷种类繁多，对检测精度提出了极高的要求，森然睿自主研发的AI视觉检测算法能够在复杂的背景下保持高精度的快速检测，确保电芯的质量符合生产要求，提高电池的整体性能和安全性。",
				"ability_text": "用于检测电芯表面凹陷、划痕、污渍;测量电芯长度、高度、宽度;电芯内部气泡、裂纹等缺陷。"
			},
			{
				"title": "软包锂电池",
				"introduce_text": "软包锂电池的表面是一层铝塑膜，具有凹凸纹理特性，存在一定的检测难度，为之易AI视觉检测算法可以在复杂的场景下对软包锂电池进行全方位外观瑕疵检测，准确识别出电池表面的各种缺陷。",
				"ability_text": "用于检测软包锂电池表面划痕、褶皱、鼓包、凹坑、脏污、极片变形、胶纸气泡、胶纸起皱、异物、翻折、压痕、刮伤。"
			},
			{
				"title": "顶盖绝缘板",
				"introduce_text": "顶盖绝缘板表面的细微缺陷可能会直接影响锂电池的性能及安全性，为之易视觉AI检测技术，能够实现对顶盖绝缘板表面的微小缺陷进行精确检测，确保其质量和性能符合设计要求。采用非接触式检测方式，不会对顶盖绝缘板造成任何损伤或污染。",
				"ability_text": "用于检测其表面翘起、压痕、污渍、溢胶、凹坑、凸点。"
			},
		],
	},
	{
		"id": 4,
		"title": "汽车",
		"content": "汽车行业，车型与零部件多样导致传统检测方法难以全面覆盖检测需求，如何应对上述挑战，提升生产效率与质量控制能力？在为之易视觉AI云平台，汽车厂商能快速安全地构建适合的AI模型，结合视觉AI检测推理软件与AI控制器，精准识别各类复杂缺陷，大幅提升检测效率与准确性。",
		"show_list": [
			{
				"title": "发动机缸体",
				"introduce_text": "发动机缸体是发动机的核心部件之一，其外观质量直接影响发动机的性能、可靠性和使用寿命。为之易基于AI模型满足发动机外观检测时的高精度、高自动化和智能化的需求。",
				"ability_text": "用于检测缸体表面的脏污、划痕、碰伤、麻点、沙眼等瑕疵。"
			},
			{
				"title": "电机定子",
				"introduce_text": "电机定子外观质量关乎电机性能。使用为之易全系列产品构建瑕疵检测模型进行检测，能准确发现定子缺陷，保障电机质量和性能，延长汽车电机使用寿命，提高可靠性。",
				"ability_text": "用于检测定子表面是否平整、无崩边、无划痕、无裂缝、无气孔等缺陷。"
			},
			{
				"title": "发动机装配",
				"introduce_text": "发动机装配环节是汽车制造中的核心工序，其质量直接决定汽车的整体性能与驾驶安全。采用为之易AI产品，构建发动机装配检测方案，能精准识别装配过程中的偏差。",
				"ability_text": "用于检测零部件缺失、发动机表面划痕、凹坑、锈蚀、螺栓、螺母等紧固件连接不到位等缺陷。"
			},
			{
				"title": "轮胎",
				"introduce_text": "轮胎外观质量是汽车行驶安全的重要保障。采用为之易视觉AI云平台构建轮胎外观缺陷检测模型，能精确捕捉表面各种瑕疵与异常，确保轮胎在制造和装配过程中符合高标准。",
				"ability_text": "用于检测轮胎外观有无划痕、凹坑、裂纹、鼓包与异物、气泡与褶皱等缺陷。"
			},
			{
				"title": "刹车片",
				"introduce_text": "刹车片作为汽车制动系统的关键组件，其外观质量直接关系到制动性能和安全性。采用为之易先进AI算法构建刹车片外观缺陷检测模型，能够精准识别并剔除存在瑕疵的刹车片。",
				"ability_text": "用于检测表面裂纹、划痕与磨损痕迹、厚度不均、尺寸偏差、异物污染、表面不平整、气泡与孔隙等缺陷。"
			},
			{
				"title": "汽车连接器",
				"introduce_text": "汽车连接器作为关键部件，其外观质量直接关乎汽车电气系统的稳定性和可靠性。采用为之易的AI检测技术，能精准识别连接器瑕疵，延长使用寿命，提升汽车整体性能。",
				"ability_text": "用于检测金属丝残留、毛刺、熔锡不良、压伤、变形、点焊偏移等关键缺陷。"
			},
			{
				"title": "轴类",
				"introduce_text": "轴类部件作为汽车传动的核心，其表面质量直接关系到车辆行驶的安全与效率。采用为之易AI检测技术，能精准捕捉轴类表面瑕疵，确保高精度加工，守护汽车动力之源。",
				"ability_text": "用于检测划痕、裂纹、锈蚀、凹凸不平等缺陷。"
			},
			{
				"title": "制动鼓铸字",
				"introduce_text": "制动鼓作为汽车制动系统的核心组件，其铸字信息对车辆维护至关重要。基于为之易AI云平台，0代码开发，只需上传图片标注即可准确识别制动鼓铸字。",
				"ability_text": "用于检测铸字模糊、缺失、错误等缺陷。"
			},
			{
				"title": "轮毂",
				"introduce_text": "轮毂作为汽车行驶的关键部件，其外观质量直接影响车辆的安全与美观。基于为之易AI云平台，即可实现0代码模型训练，利用机器视觉技术实现轮毂外观检测，确保轮毂质量。",
				"ability_text": "用于检测划痕、凹陷、锈蚀等缺陷。"
			},
		],
	},
	{
		"id": 5,
		"title": "食品医药",
		"content": "食品医药行业产品种类繁多，规格各异，其质量直接关系到生命安全。为之易视觉AI生态链构建新型AI人工智能视觉检测架构，涵盖从AI云服务平台、AI检测推理软件到AI视觉控制器的完整体系，能够根据不同产品的特点和需求进行定制和调整，在产品出厂前对其各类特征进行视觉检测，确保产品符合法规要求。",
		"show_list": [
			{
				"title": "输液针头",
				"introduce_text": "输液针头外形微小，生产规模庞大，为之易AI算法模型能够在识别针头的微小缺陷的同时保证产品的高效率检测。",
				"ability_text": "用于检测针尖毛刺、针尖缺失、针管弯曲、杂质、压伤等。"
			},
			{
				"title": "药片",
				"introduce_text": "药片的视觉检测确保了药品的质量和一致性，是药品生产过程中至关重要的一环，采用为之易AI视觉检测技术，可以及时发现并排除存在缺陷的药片，从而确保药品的安全性和有效性。",
				"ability_text": "用于检测药片残缺、划痕、表面污渍及字符识别等。"
			},
			{
				"title": "医用纱布",
				"introduce_text": "医用纱布作为重要的医疗用品，其质量直接关系到患者的安全和健康。为之易AI视觉检测技术可以对纱布生产过程中可能出现的各种表面缺陷进行全面检测，以确保产品质量符合医疗卫生用品标准。",
				"ability_text": "用于检测纱布表面孔洞、边缘缺失、断经/断纬、杂质、油污、起球、污渍、打结。"
			},
			{
				"title": "医用塑胶瓶",
				"introduce_text": "医用塑胶瓶的首要职责是确保药品在储存和运输过程中不受污染、不变质。通过先进的人工智能视觉技术对其进行一系列严格的检测，可以使医用塑胶瓶的质量符合相关标准和要求，进一步促进医疗标准化。",
				"ability_text": "检查医用塑胶瓶的外观是否平整、无明显缺陷，如裂纹、气泡、凹陷等；测量医用塑胶瓶的长度、宽度、高度、瓶口直径、瓶身直径等尺寸。"
			},
			{
				"title": "泡罩",
				"introduce_text": "医用泡罩作为药品的包装形式，直接关系到药品的包装质量和患者的用药安全，采用为之易AI视觉算法可以对其完整性、密封性和标签信息的准确性进行高效率检测。",
				"ability_text": "用于检测泡罩内的药粒破损、变形、异物；泡罩封口破损、漏气。"
			},
			{
				"title": "胶囊外观",
				"introduce_text": "胶囊作为药品的一种常见剂型，其外观质量直接反映了药品的生产工艺和质量控制水平，针对其外观检测可以确保药品的完整性和安全性，排除药品可能会对患者的健康造成潜在威胁。",
				"ability_text": "用于检测胶囊长度、直径、变形、凹陷、色差、异色、表面污渍、裂纹、划痕。"
			},
			{
				"title": "口罩",
				"introduce_text": "口罩作为重要的个人防护用品，其质量、安全性和有效性备受关注。通过为之易自研AI视觉检测系统可以及时发现口罩在生产过程中可能存在的缺陷和问题，确保口罩符合相关标准和规定，保障消费者的权益和健康。",
				"ability_text": "用于检测口罩尺寸、外观破损、污渍、异物；鼻梁条、耳带等部件缺失；连接点缺失、偏移。"
			},
			{
				"title": "安瓿瓶",
				"introduce_text": "安瓿瓶具有优异的化学稳定性和透明度，能确保药品不受光、氧气和其他气体的影响，视觉检测能够精确识别安瓿瓶内部的可见异物和外部的瑕疵，确保药品在封装过程中不受污染或损伤，从而保障药品的质量和安全性。",
				"ability_text": "用于检测安瓿瓶的形状、尺寸、颜色、透明度、表面光洁度、破损、变形、缺失、裂纹；瓶内异物：尘埃、纤维、碎片等。"
			},
			{
				"title": "注射器",
				"introduce_text": "医用注射器是直接接触人体的医疗器具，具有严格的出厂标准，对检测精度与效率有极高的要求，采用为之易AI视觉检测技术，可以对注射器进行高效、精确的瑕疵检测，为医用注射器行业的发展提供更加有力的支持。",
				"ability_text": "用于检测注射器无针 、无钢片、针弯 、内筒毛发异物 、无护套、 耳朵缺胶等瑕疵 。"
			},
			{
				"title": "医用敷贴",
				"introduce_text": "医用敷贴会直接与患者皮肤接触，采用为之易AI视觉检测技术，能够全面、细致地检查医用敷贴的外观质量，及时发现并剔除存在缺陷的产品，确保每一片敷贴都符合相关标准和规定，从而保障患者的使用安全和舒适。",
				"ability_text": "用于检测医用敷贴表面黑点、污染、异物、褶皱、敷芯缺失、毛边、为打孔等缺陷。"
			},
			{
				"title": "鹌鹑蛋",
				"introduce_text": "鹌鹑蛋外观缺陷细小且多样，人工目检耗时费力不准确。通过为之易的视觉AI检测技术和产品，这些瑕疵和缺陷能够被精准、快速地识别出来。",
				"ability_text": "用于检测夹蛋壳、夹料、夹蛋黄、异物、色素沉积、双蛋黄、漏气等不良瑕疵。"
			},
			{
				"title": "方便面面饼",
				"introduce_text": "方便面面饼外观检测是一个复杂而细致的过程，需要关注多个方面的缺陷和问题。通过为之易AI检测技术，可以及时发现并剔除不合格产品，确保产品的品质和消费者的健康。",
				"ability_text": "用于检测有无油渣、焦糊等缺陷。"
			},
			{
				"title": "农产品分选",
				"introduce_text": "农产品种类繁多、外观形态各异，传统检测方法往往难以高效、精准地完成检测任务。而为之易AI视觉检测凭借其强大的图像识别与处理能力，能够自动识别农产品的缺陷、病虫害、成熟度等关键信息，实现快速、准确地检测与分选定级。",
				"ability_text": "用于对苹果、西红柿、玉米、棉花等农产品进行特征识别、缺陷检测、分类分级。"
			},
			{
				"title": "零食",
				"introduce_text": "针对面包糕点、鸡爪、辣条、多粒肠、鱼豆腐、猪肉脯、亲嘴烧等零食，为之易基于机器视觉技术及时发现并剔除不合格产品，确保商品品质。",
				"ability_text": "用于检测夹料、异物、脏污、破损、多料少料等缺陷。"
			},
			{
				"title": "馄饨",
				"introduce_text": "使用为之易的视觉AI技术平台，借助其强大的目标定位功能，用户仅需上传馄饨包装的图片并进行简单标注，即可轻松定制出专属的机器视觉检测方案。",
				"ability_text": "精准地对馄饨个体进行计数与定位，智能判断馄饨的数量与位置是否满足既定的生产标准。"
			},
		],
	},
	{
		"id": 6,
		"title": "零售",
		"content": "零售行业的每一项运营指标都有可能直接影响其经营效益，为之易AI视觉检测技术能够多维度识别分析店铺的运营状况，为运营者改善经营模式提供数据基础，可以有效提升零售行业务的运营效率，优化顾客消费体验，增强其市场竞争力。",
		"show_list": [
			{
				"title": "商品外观",
				"introduce_text": "商品进入零售环节将直接面对消费者，其外观状况直接决定其是否被购买，通过为之易AI视觉检测算法，可以直接对商品外观进行全面检测，快速识别并排除瑕疵商品，确保只有高质量商品进入零售环节。",
				"ability_text": "-"
			},
			{
				"title": "商品库存管理",
				"introduce_text": "商品库存是零售业的一项重要指标，人工操作耗时且存在失误，采用为之易人工智能视觉检测算法，可以识别入库商品并计数，为库存规划提供数据基础，避免库存积压导致运营成本增加。",
				"ability_text": "-"
			},
			{
				"title": "商品陈列分类",
				"introduce_text": "商品的陈列关系到其销售状况，消费者选购商品时可能会移动商品，导致商品陈列混乱，使用为之易人工智能视觉检测算法，可以对商品陈列异常进行检测识别，从而及时调整，保持货架的整洁有序，提高购物效率。",
				"ability_text": "-"
			},
			{
				"title": "商品效益评估",
				"introduce_text": "为之易AI视觉检测算法可以对消费者在店内的移动轨迹、区域停留时长等购物行为和商品复购情况进行识别并分类统计，为运营者改善经营模式提供数据基础。",
				"ability_text": "-"
			},
			{
				"title": "快速结账",
				"introduce_text": "传统的结账模式效率低，为之易视觉AI检测算法通过检测商品外观识别商品并计数，可以提高结账效率，减少排队时间。",
				"ability_text": "-"
			},
			{
				"title": "异常行为检测",
				"introduce_text": "为之易人工智能视觉检测技术可以识别店内人员盗窃、破坏等可疑行为，能够让运营者及时发现并处理异常情况，保障店铺安全。",
				"ability_text": "-"
			},
		],
	},
	{
		"id": 7,
		"title": "物流",
		"content": "物流行业存在大量的货物处理，每一个环节的失误都可能导致成本增加，甚至客户投诉，采用为之易自主研发的人工智能视觉检测算法，可以对物流各环节的不同对象进行精确检测及测量，有效减少人为因素导致的错误和遗漏，从而降低成本提高效益。",
		"show_list": [
			{
				"title": "货品分拣",
				"introduce_text": "人工分拣效率低下，采用为之易AI视觉算法，可以识别货品形状、颜色和条码信息并将其分类，结合机器人技术可以实现货物自动分拣，大大提高分拣效率。",
				"ability_text": "-"
			},
			{
				"title": "货品包装",
				"introduce_text": "货品包装的质量可能会影响其交付，运用为之易人工智能视觉检测算法，可以对货品外包装进行全面检测，及时识别不良包装，提升货物的交付质量。",
				"ability_text": "-"
			},
			{
				"title": "货品外观",
				"introduce_text": "空间利用率是货物存储管理的重要指标，为之易AI视觉检测算法可以精确测量各类货物的尺寸，结合货物尺寸数据，规划存放空间，能够有效提升空间利用率，降低运营成本。",
				"ability_text": "-"
			},
			{
				"title": "装载优化",
				"introduce_text": "货品装车是物流运输不可缺少的环节，车内货物装载不足可能会给企业带来一定的损失，为之易自主研发的人工智能视觉检测技术，可以对车内空间实时监测并及时反馈信息，避免车辆空载或部分空载等情况出现。",
				"ability_text": "-"
			},
			{
				"title": "安全检测",
				"introduce_text": "在物流作业场景中危险是难以避免的，为之易AI视觉检测算法可以检测作业人员防护设备的合规性及作业区域的安全性并实时反馈，为生产作业带来更高的安全性。",
				"ability_text": "-"
			},
			{
				"title": "路径优化",
				"introduce_text": "在自动化仓库中，通过为之易视觉AI视觉检测算法可以实时检测其内部道路是否存在障碍物，从而优化搬运机器人的行进路径。",
				"ability_text": "-"
			},
		],
	},

]

export default {
	api_list_data,
	product_list_data_1,
	product_list_data_2,
	product_list_data_3,
	product_list_data_4,
	device_tabs_index,
	flask_web_url,
	flask_web_local_url,
	public_yAxis,
	public_dataZoom,
	public_tooltip,
	public_toolbox,
	data_chistory_show_1,
	data_chistory_show_2,
	data_chistory_show_3,
	data_chistory_show_4,
	data_chistory_show_5,
	data_chistory_show_6,
	data_chistory_show_7,
	map_data_info,
	tdtMap,
	map_marker,
	map_marker_content,
	map_label,
	now_device_id,
	device_info_data_obj,
	markers_list,
	methods: {
		init_header_menu(path) {
			setTimeout(function () {
				document.getElementById("page1").className = "el-menu-item"
				document.getElementById("page2").className = "el-menu-item"
				document.getElementById("page3").className = "el-menu-item"
				document.getElementById("page5").className = "el-menu-item"
				document.getElementById("page6").className = "el-menu-item"
				document.getElementById("page7").className = "el-menu-item"

				window.localStorage.setItem("main_path", path);
				document.getElementById(path).className = "el-menu-item is-active"

				console.log("init_header_menu:     " + path)
			}, 10)

		},
		// 判断用户权限
		check_permission(val) {
			return new Promise((resolve, reject) => {
				//当第三方api提供的是异步方法
				// resolve();
				let user_data = {
					user: sessionStorage.getItem("user"),
					power: sessionStorage.getItem("power"),
					action: val
				}
				request.post(flask_web_url + '/check_permission', user_data).then(res => {
					if (res == "500") {
						ElMessage.error('用户数据异常,请重新登录！！！')
						sessionStorage.removeItem("user");
						sessionStorage.clear()
						resolve("500");
					}
					else {
						// ElMessage.success('校验成功')
						resolve(res);
					}
				}).catch(function (res) {
					console.error(res)
					ElMessage.error('服务器异常 ！！！')
					resolve("404");
				})
			})

			// console.log(sessionStorage.getItem("user"))

		},
	},
}
</script>

<style></style>